"use client";

import Link from "next/link";
import { forwardRef, type ComponentProps, type MouseEvent } from "react";

import { useAppContext } from "@/context/AppContext";
import { useSessionContext } from "@/context/SessionContext";
import { storePendingAuthMode } from "@/lib/auth-navigation";

type RegistrationLinkProps = ComponentProps<typeof Link> & {
  product?: string;
};

export const RegistrationLink = forwardRef<
  HTMLAnchorElement,
  RegistrationLinkProps
>(({ onClick, product, ...props }, ref) => {
  const { setDoLogin } = useAppContext();
  const { setDoForgottenPassword, setSelectedProduct } = useSessionContext();

  const openRegistration = (event: MouseEvent<HTMLAnchorElement>) => {
    setDoLogin(false);
    setDoForgottenPassword(false);
    storePendingAuthMode("register");

    if (product) {
      setSelectedProduct(product);
    }

    onClick?.(event);
  };

  return <Link ref={ref} onClick={openRegistration} {...props} />;
});

RegistrationLink.displayName = "RegistrationLink";
